import $ from 'jquery';
import Swal from 'sweetalert2';
import AjaxList from '../ajax-list/ajax-lists';
import { initGlobalSelect2 } from '../utils/select2-utils';
import { populateForm } from '../utils/form-utils';

/**
 * Initialize Master Data CRUD functionality
 * Handles modals, AJAX data fetching, and deletions.
 */
export function initMasterData() {
    const pageId = $('#page-id').data('page');
    if (!pageId) return;

    console.log(`[MasterData] Initializing for page: ${pageId}`);




    // --- 1. Generic Modal Handling (skip for trash pages) ---
    let pageConfigs = getPageConfig(pageId);
    if (!pageConfigs) return; // Trash pages stop here — no modal needed
    if (!Array.isArray(pageConfigs)) pageConfigs = [pageConfigs];

    pageConfigs.forEach(config => {
        const modalCreateElement = document.getElementById(config.modalId);
        const modalEditElement = document.getElementById(config.modalEditId || config.modalId);
        if (!modalCreateElement) return;

        const modalCreate = new window.bootstrap.Modal(modalCreateElement);
        const modalEdit = modalEditElement === modalCreateElement ? modalCreate : new window.bootstrap.Modal(modalEditElement);

        const $formCreate = $(`#${config.formId}`);
        const $formEdit = $(`#${config.formEditId || config.formId}`);

        const $modalCreateTitle = $(`#${config.modalLabel}`);
        const $modalEditTitle = $(`#${config.modalEditLabel || config.modalLabel}`);

        const $btnSubmitCreate = $formCreate.find('button[type="submit"]');
        const $btnSubmitEdit = $formEdit.find('button[type="submit"]');

        // Select2 initialization is now handled globally in app.js for all modals

        // Trigger Update (Load Data via AJAX)
        $(document).on('click', `.${config.btnEditClass}`, async function (e) {
            // Guard: Prevent firing if triggered from a view-detail button
            if ($(this).hasClass('btn-view-detail') || $(e.target).closest('.btn-view-detail').length) {
                return;
            }
            const id = $(this).data('id');
            const url = $(this).data('url-json');

            if (!url) {
                console.error('Error: Edit URL is missing for element:', this);
                return;
            }

            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const result = await response.json();

                if (result.status === 'success') {
                    $modalEditTitle.text(config.titleEdit);
                    $btnSubmitEdit.text('Update Data');
                    modalEdit.show();

                    // Populate form after showing modal
                    await populateForm($formEdit, result.data);
                } else {
                    Swal.fire('Error', result.message || 'Gagal mengambil data', 'error');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                Swal.fire('Error', `Gagal mengambil data sistem: ${error.message}`, 'error');
            }
        });

        // Trigger Create (Reset Form)
        $(document).on('click', `#${config.btnCreateId}`, function () {
            // Destroy Select2 first to avoid cascading issues during reset
            $formCreate.find('select.select2-hidden-accessible').each(function () {
                $(this).select2('destroy');
            });

            $formCreate[0].reset();
            $formCreate.find('input[type="hidden"]').val('');

            // Re-assign default hidden fields like id_tipe if they exist in the config
            if (config.defaultValues) {
                Object.keys(config.defaultValues).forEach(k => {
                    $formCreate.find(`input[name="${k}"]`).val(config.defaultValues[k]);
                });
            }

            // Reset ALL select values silently (no trigger to avoid cascading)
            $formCreate.find('select').each(function () {
                $(this).val(null);
            });

            $modalCreateTitle.text(config.titleCreate);
            $btnSubmitCreate.text('Simpan Data');

            // Note: Select2 will be re-initialized in app.js via shown.bs.modal event
        });
    });

    // --- 4. Global Import Excel (Chunked Support) ---
    $(document).on('submit', 'form[id*="Import"]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $form = $(this);
        const $btn = $form.find('button[type="submit"]');
        const $progressContainer = $form.find('#importProgress');
        const $progressBar = $form.find('.progress-bar');
        const $status = $form.find('#importStatus');
        const formData = new FormData(this);

        // UI Reset
        $btn.prop('disabled', true);
        $progressContainer.removeClass('d-none');
        $progressBar.css('width', '0%').text('0%');
        $status.text('Mengunggah file...');

        // Step 1: Initialize Import (Upload & Get Total Rows)
        const initUrl = $form.attr('action').replace('/import', '/init-import');

        $.ajax({
            url: initUrl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }

                if (res.status === 'success') {
                    const totalRows = res.totalRows;
                    const tempFile = res.tempFile;
                    const chunkSize = 500; // Rows per request
                    let currentStart = 2; // Excel row starts at 2 (1 is header)

                    // Accumulator for errors & stats across all chunks
                    const importState = {
                        totalProcessed: 0,
                        allErrors: []
                    };

                    processChunk(tempFile, currentStart, chunkSize, totalRows, $form, importState);
                } else {
                    Swal.fire('Error', res.message || 'Gagal inisialisasi import', 'error');
                    resetImportUI($form);
                }
            },
            error: function (xhr) {
                Swal.fire('Error', xhr.responseJSON?.message || 'Gagal mengunggah file', 'error');
                resetImportUI($form);
            }
        });
    });

    function processChunk(tempFile, startRow, chunkSize, totalRows, $form, importState) {
        const $progressBar = $form.find('.progress-bar');
        const $status = $form.find('#importStatus');
        const chunkUrl = $form.attr('action').replace('/import', '/import-chunk');

        const isLastChunk = (startRow + chunkSize) >= totalRows;

        const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || $('input[name*="csrf_"]').first().val();

        let postData = {
            tempFile: tempFile,
            startRow: startRow,
            chunkSize: chunkSize,
            isLastChunk: isLastChunk
        };

        if (csrfTokenName && csrfHash) {
            postData[csrfTokenName] = csrfHash;
        }

        $.ajax({
            url: chunkUrl,
            type: 'POST',
            data: postData,
            success: function (res) {
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }
                if (res.status === 'success') {
                    importState.totalProcessed += res.processed || 0;

                    // Collect errors from this chunk
                    if (res.errors && res.errors.length > 0) {
                        importState.allErrors = importState.allErrors.concat(res.errors);
                    }

                    const currentRow = Math.min(startRow + chunkSize - 1, totalRows);
                    const percent = Math.min(Math.round((currentRow / totalRows) * 100), 100);

                    $progressBar.css('width', percent + '%').text(percent + '%');
                    $status.text(`Memproses: ${currentRow} dari ${totalRows} baris...`);

                    if (!isLastChunk) {
                        processChunk(tempFile, startRow + chunkSize, chunkSize, totalRows, $form, importState);
                    } else {
                        $status.text('Import selesai!');
                        showImportResult(importState, totalRows);
                    }
                } else {
                    Swal.fire('Error', res.message || 'Gagal memproses chunk data', 'error');
                    resetImportUI($form);
                }
            },
            error: function (xhr) {
                Swal.fire('Error', xhr.responseJSON?.message || 'Gagal memproses data', 'error');
                resetImportUI($form);
            }
        });
    }

    function escapeHtml(str) {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    function showImportResult(importState, totalRows) {
        const errorCount = importState.allErrors.length;
        const successCount = importState.totalProcessed;

        if (errorCount === 0) {
            // All rows imported successfully
            Swal.fire({
                icon: 'success',
                title: 'Import Berhasil',
                html: `<b>${successCount}</b> data berhasil diimport.`,
                confirmButtonText: 'OK'
            }).then(() => location.reload());
        } else {
            // Some rows had errors
            const maxShow = 20;
            let errorListHtml = '<div style="text-align:left; max-height:300px; overflow-y:auto; font-size:13px;">';
            errorListHtml += '<ul style="padding-left:18px; margin:0;">';

            const displayErrors = importState.allErrors.slice(0, maxShow);
            displayErrors.forEach(err => {
                errorListHtml += `<li style="margin-bottom:4px; color:#c0392b;">${escapeHtml(err)}</li>`;
            });

            if (errorCount > maxShow) {
                errorListHtml += `<li style="color:#7f8c8d;">...dan ${errorCount - maxShow} error lainnya</li>`;
            }
            errorListHtml += '</ul></div>';

            Swal.fire({
                icon: successCount > 0 ? 'warning' : 'error',
                title: successCount > 0 ? 'Import Selesai dengan Catatan' : 'Import Gagal',
                html: `
                    <p><b>${successCount}</b> data berhasil diimport.</p>
                    <p><b style="color:#e74c3c;">${errorCount}</b> baris dilewati karena data master tidak ditemukan:</p>
                    ${errorListHtml}
                `,
                width: 600,
                confirmButtonText: 'OK'
            }).then(() => {
                if (successCount > 0) location.reload();
            });
        }
    }

    function resetImportUI($form) {
        $form.find('button[type="submit"]').prop('disabled', false);
        $form.find('#importProgress').addClass('d-none');
    }
    // --- 8. Specific Master Data Helpers (Tiang/Penyulang Auto-Fill) ---
    $(document).on('change', '#id_up3', function () {
        const $form = $(this).closest('form');
        const $codeField = $form.find('#cxup3');
        if (!$codeField.length) return;

        const selectedOption = $(this).find('option:selected');
        const code = selectedOption.data('code');
        if (code) {
            $codeField.val(code);
        } else {
            const text = selectedOption.text();
            if (text && !text.includes('--')) $codeField.val(text.trim());
        }
    });

    $(document).on('change', '#id_ulp', function () {
        const $form = $(this).closest('form');
        const $codeField = $form.find('#cxunit');
        if (!$codeField.length) return;

        const selectedOption = $(this).find('option:selected');
        const ulpId = $(this).val();
        let code = selectedOption.data('code');

        if (code) {
            $codeField.val(code);
            return;
        }

        if (ulpId) {
            AjaxList.getUlp().then(data => {
                if (data && Array.isArray(data)) {
                    const ulp = data.find(u => u.id_ulp == ulpId);
                    if (ulp && ulp.kode_ulp) {
                        $codeField.val(ulp.kode_ulp);
                        selectedOption.data('code', ulp.kode_ulp);
                    }
                }
            });
        }
    });
}

/**
 * Configure page-specific selectors and titles
 */
function getPageConfig(page) {
    const base = {
        btnDeleteClass: 'btn-delete-submit'
    };

    const configs = {
        'unit-induk': {
            modalId: 'modalUnitInduk',
            formId: 'formUnitInduk',
            modalLabel: 'modalUnitIndukLabel',
            btnCreateId: 'btnCreateUnitInduk',
            btnEditClass: 'btn-edit-unit-induk',
            titleCreate: 'Tambah Unit Induk',
            titleEdit: 'Edit Unit Induk'
        },
        'jabatan': {
            modalId: 'modalJabatan',
            formId: 'formJabatan',
            modalLabel: 'modalJabatanLabel',
            btnCreateId: 'btnCreateJabatan',
            btnEditClass: 'btn-edit-jabatan',
            titleCreate: 'Tambah Jabatan',
            titleEdit: 'Edit Jabatan'
        },
        'level-jabatan': {
            modalId: 'modalLevel',
            formId: 'formLevel',
            modalLabel: 'modalLevelLabel',
            btnCreateId: 'btnCreateLevel',
            btnEditClass: 'btn-edit-level',
            titleCreate: 'Tambah Level Jabatan',
            titleEdit: 'Edit Level Jabatan'
        },
        'tipe-pegawai': {
            modalId: 'modalTipe',
            formId: 'formTipe',
            modalLabel: 'modalTipeLabel',
            btnCreateId: 'btnCreateTipe',
            btnEditClass: 'btn-edit-tipe',
            titleCreate: 'Tambah Tipe Pegawai',
            titleEdit: 'Edit Tipe Pegawai'
        },
        'up3': {
            modalId: 'modalUp3',
            formId: 'formUp3',
            modalLabel: 'modalUp3Label',
            btnCreateId: 'btnCreateUp3',
            btnEditClass: 'btn-edit-up3',
            titleCreate: 'Tambah UP3',
            titleEdit: 'Edit UP3'
        },
        'ulp': {
            modalId: 'modalUlp',
            formId: 'formUlp',
            modalLabel: 'modalUlpLabel',
            btnCreateId: 'btnCreateUlp',
            btnEditClass: 'btn-edit-ulp',
            titleCreate: 'Tambah ULP',
            titleEdit: 'Edit ULP'
        },
        'kantor-jaga': {
            modalId: 'modalKantorJaga',
            formId: 'formKantorJaga',
            modalLabel: 'modalKantorJagaLabel',
            modalEditId: 'modalEditKantorJaga',
            formEditId: 'formEditKantorJaga',
            modalEditLabel: 'modalEditKantorJagaLabel',
            btnCreateId: 'btnCreateKantorJaga',
            btnEditClass: 'btn-edit-kantor-jaga',
            titleCreate: 'Tambah Kantor Jaga',
            titleEdit: 'Edit Kantor Jaga'
        },
        'pohon': {
            modalId: 'modalPohon',
            formId: 'formPohon',
            modalLabel: 'modalLabel',
            btnCreateId: 'btnCreatePohon',
            btnEditClass: 'btn-edit-pohon',
            titleCreate: 'Tambah Pohon',
            titleEdit: 'Edit Pohon'
        },
        'komponen': {
            modalId: 'modalKomponen',
            formId: 'formKomponen',
            modalLabel: 'modalLabel',
            btnCreateId: 'btnCreateKomponen',
            btnEditClass: 'btn-edit-komponen',
            titleCreate: 'Tambah Komponen',
            titleEdit: 'Edit Komponen'
        },
        'kondisi': {
            modalId: 'modalKondisi',
            formId: 'formKondisi',
            modalLabel: 'modalLabel',
            btnCreateId: 'btnCreateKondisi',
            btnEditClass: 'btn-edit-kondisi',
            titleCreate: 'Tambah Kondisi',
            titleEdit: 'Edit Kondisi'
        },
        'zona': {
            modalId: 'modalZona',
            formId: 'formZona',
            modalLabel: 'modalZonaLabel',
            btnCreateId: 'btnCreateZona',
            btnEditClass: 'btn-edit-zona',
            titleCreate: 'Tambah Zona',
            titleEdit: 'Edit Zona'
        },
        'row': {
            modalId: 'modalRow',
            formId: 'formRow',
            modalLabel: 'modalRowLabel',
            btnCreateId: 'btnCreateRow',
            btnEditClass: 'btn-edit-row',
            titleCreate: 'Tambah Data ROW',
            titleEdit: 'Edit Data ROW'
        },



        'vendor': {
            modalId: 'modalVendor',
            formId: 'formVendor',
            modalLabel: 'modalVendorLabel',
            btnCreateId: 'btnCreateVendor',
            btnEditClass: 'btn-edit-vendor',
            titleCreate: 'Tambah Vendor',
            titleEdit: 'Edit Vendor'
        },
        'pegawai': [
            {
                modalId: 'modalPegawaiInternal',
                formId: 'formPegawaiInternal',
                modalLabel: 'modalPegawaiInternalLabel',
                btnCreateId: 'btnCreatePegawaiPLN',
                btnEditClass: 'btn-edit-pegawai-pln',
                titleCreate: 'Tambah Pegawai PLN',
                titleEdit: 'Edit Pegawai PLN'
            },
            {
                modalId: 'modalPegawaiMitra',
                formId: 'formPegawaiMitra',
                modalLabel: 'modalPegawaiMitraLabel',
                btnCreateId: 'btnCreatePegawaiMitra',
                btnEditClass: 'btn-edit-pegawai-mitra',
                titleCreate: 'Tambah Pegawai Mitra',
                titleEdit: 'Edit Pegawai Mitra'
            }
        ],
        'penyulang': {
            modalId: 'modalPenyulang',
            formId: 'formPenyulang',
            modalLabel: 'modalPenyulangLabel',
            btnCreateId: 'btnCreatePenyulang',
            btnEditClass: 'btn-edit-penyulang',
            titleCreate: 'Tambah Penyulang',
            titleEdit: 'Edit Penyulang'
        },
        'tiang': {
            modalId: 'modalTiang',
            formId: 'formTiang',
            modalLabel: 'modalTiangLabel',
            btnCreateId: 'btnCreateTiang',
            btnEditClass: 'btn-edit-tiang',
            titleCreate: 'Tambah Tiang',
            titleEdit: 'Edit Tiang'
        },
        'material': {
            modalId: 'modalMaterial',
            formId: 'formMaterial',
            modalLabel: 'modalMaterialLabel',
            btnCreateId: 'btnCreateMaterial',
            btnEditClass: 'btn-edit-material',
            titleCreate: 'Tambah Material',
            titleEdit: 'Edit Material'
        },
        'pekerjaan': {
            modalId: 'modalPekerjaan',
            formId: 'formPekerjaan',
            modalLabel: 'modalPekerjaanLabel',
            btnCreateId: 'btnCreatePekerjaan',
            btnEditClass: 'btn-edit-pekerjaan',
            titleCreate: 'Tambah Pekerjaan',
            titleEdit: 'Edit Pekerjaan'
        },
        'segment': {
            modalId: 'modalSegment',
            formId: 'formSegment',
            modalLabel: 'modalSegmentLabel',
            modalEditId: 'modalEditSegment',
            formEditId: 'formEditSegment',
            modalEditLabel: 'modalEditSegmentLabel',
            btnCreateId: 'btnCreateSegment',
            btnEditClass: 'btn-edit-segment',
            titleCreate: 'Tambah Segment',
            titleEdit: 'Edit Segment'
        },
        'percabangan': {
            modalId: 'modalPercabangan',
            formId: 'formPercabangan',
            modalLabel: 'modalPercabanganLabel',
            btnCreateId: 'btnCreatePercabangan',
            btnEditClass: 'btn-edit-percabangan',
            titleCreate: 'Tambah Percabangan',
            titleEdit: 'Edit Percabangan'
        },
        'tegakan': {
            modalId: 'modalTegakan',
            formId: 'formTegakan',
            modalLabel: 'modalTegakanLabel',
            btnCreateId: 'btnCreateTegakan',
            btnEditClass: 'btn-edit-tegakan',
            titleCreate: 'Tambah Tegakan',
            titleEdit: 'Edit Tegakan'
        },
        'material-vendor': {
            modalId: 'modalMaterialVendor',
            formId: 'formMaterialVendor',
            modalLabel: 'modalLabel',
            btnCreateId: 'btnCreateMaterialVendor',
            btnEditClass: 'btn-edit-material-vendor',
            titleCreate: 'Tambah Stok Vendor',
            titleEdit: 'Edit Stok Vendor'
        },
        'material-item': {
            modalId: 'modalMaterialItem',
            formId: 'formMaterialItem',
            modalLabel: 'modalLabel2',
            btnCreateId: 'btnCreateMaterialItem',
            btnEditClass: 'btn-edit-material-item',
            titleCreate: 'Tambah Fisik Material',
            titleEdit: 'Edit Fisik Material'
        },
        'jenis-pekerjaan': {
            modalId: 'modalJenisPekerjaan',
            formId: 'formJenisPekerjaan',
            modalLabel: 'modalJenisPekerjaanLabel',
            btnCreateId: 'btnCreateJenisPekerjaan',
            btnEditClass: 'btn-edit-jenis-pekerjaan',
            titleCreate: 'Tambah Jenis Pekerjaan',
            titleEdit: 'Edit Jenis Pekerjaan'
        },
        'objek-pekerjaan': {
            modalId: 'modalObjek',
            formId: 'formObjek',
            modalLabel: 'modalObjekLabel',
            btnCreateId: 'btnCreateObjek',
            btnEditClass: 'btn-edit-objek',
            titleCreate: 'Tambah Objek Pekerjaan',
            titleEdit: 'Edit Objek Pekerjaan'
        },
        'kategori-asset': {
            modalId: 'modalKategoriAsset',
            formId: 'formKategoriAsset',
            modalLabel: 'modalKategoriAssetLabel',
            btnCreateId: 'btnCreateKategoriAsset',
            btnEditClass: 'btn-edit-kategori-asset',
            titleCreate: 'Tambah Kategori Asset',
            titleEdit: 'Edit Kategori Asset'
        },
        'inspeksi': {
            modalId: 'modalInspeksi',
            formId: 'formInspeksi',
            modalLabel: 'modalInspeksiLabel',
            btnCreateId: 'btnCreateInspeksi',
            btnEditClass: 'btnEdit',
            titleCreate: 'Tambah Inspeksi',
            titleEdit: 'Edit Inspeksi'
        }
    };

    if (configs[page]) {
        if (Array.isArray(configs[page])) {
            return configs[page].map(c => ({ ...base, ...c }));
        }
        return { ...base, ...configs[page] };
    }
    return null;
}
